<a class="cpv-download-link btn btn-primary" href="{{ cpvListUrl }}">{{ cpvListLinkLabel }}</a>
<div class="table-card">
  <div *ngIf="isGestionComptesAnnonceur" class="card" id="card-add">
    <div class="card-add" (click)="createList()">
      <div class="cercle-dashed">
        <mat-icon class="add-icon">add</mat-icon>
      </div>
      <h2>{{ preferenceMessages.tab_2_label_2 | translate }}</h2>
    </div>
  </div>
  <div *ngFor="let item of sortList" class="card">
    <div class="etiquette-group">
      <h2 class="text-etiquette">{{item.titre}}</h2>
      <mat-icon *ngIf="isGestionComptesAnnonceur" class="icon-etiquette icon" (click)="update(item)">create</mat-icon>
      <mat-icon *ngIf="isGestionComptesAnnonceur" class="icon-etiquette icon" (click)="delete(item)">delete_outline</mat-icon>
      <app-partage-preference [id]="item.id" class="icon-etiquette"></app-partage-preference>
    </div>
    <div class="label-pos">
      <label>{{ item.compteur }} {{ preferenceMessages.tab_2_label_3 | translate }}</label>
    </div>
    <div class="content">
      <span *ngFor="let val of item.values">{{val}}</span>
    </div>
  </div>
</div>
